module.exports = __webpack_public_path__ + "static/icons-set.12b86b8d.svg";